import React from "react";
import { Linkedin, Mic2, PenLine, BookOpen, Calendar, Globe, ArrowRight } from "lucide-react";

const CreditsSection = ({ darkMode, brief }) => {
  const dm = darkMode;
  const links = [
    { label: "LinkedIn", href: "https://www.linkedin.com/in/mirkolalli/", Icon: Linkedin },
    { label: "Podcast", href: "https://open.spotify.com/show/6bR4RxYdRmSoaRR3BHdPmT", Icon: Mic2 },
    { label: "Medium", href: "https://medium.com/@mkl", Icon: PenLine },
    { label: "Book", href: "https://www.amazon.com/dp/B0CW1BRDYH", Icon: BookOpen },
    { label: "Invite to speak", href: "https://calendar.app.google/K2yV4ZJzAMgdrr2Z7", Icon: Calendar },
    { label: "mirkolalli.me", href: "https://mirkolalli.me", Icon: Globe },
  ];

  return (
    <div data-testid="credits-section" className={`mt-10 rounded-2xl p-8 ${dm ? "bg-[#1a2122]" : "bg-white"}`} style={{ boxShadow: "0 0 0 1px rgba(186,201,204,0.08), 0 4px 24px rgba(25,28,29,0.04)" }}>
      <p className={`category-tag mb-6 ${dm ? "text-slate-600" : "text-[#bac9cc]"}`}>CURATOR</p>
      <div className="flex flex-col md:flex-row items-start md:items-center gap-7">
        {brief?.author_photo_url ? (
          <img src={brief.author_photo_url} alt={brief.author_name || "Mirko Lalli"} data-testid="credits-author-photo"
            className="w-14 h-14 rounded-2xl object-cover flex-shrink-0 ring-2"
            style={{ ringColor: dm ? "#22d3ee" : "#006874" }}
            onError={e => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); }} />
        ) : (
          <div className={`w-14 h-14 rounded-2xl flex-shrink-0 flex items-center justify-center text-base font-black tracking-tight flex-col ${dm ? "bg-cyan-400/10 text-cyan-400" : "bg-[#006874]/8 text-[#006874]"}`}
            style={{ fontFamily: "'Space Grotesk', sans-serif", lineHeight: 1 }} data-testid="credits-author-monogram">MKL</div>
        )}
        <div className="flex-1">
          <div className="flex items-center flex-wrap gap-3 mb-1">
            <h3 className={`editorial-heading text-xl font-medium ${dm ? "text-slate-100" : "text-[#191c1d]"}`}>Mirko Lalli</h3>
            <a href="https://mirkolalli.me" target="_blank" rel="noopener noreferrer" data-testid="mirkolalli-link"
              className={`category-tag flex items-center gap-1 transition-colors ${dm ? "text-cyan-400/70 hover:text-cyan-400" : "text-[#006874]/70 hover:text-[#006874]"}`}>
              mirkolalli.me <ArrowRight className="w-2.5 h-2.5" />
            </a>
          </div>
          <p className={`category-tag mb-3 ${dm ? "text-slate-500" : "text-[#6b7a7d]"}`}>AI & Tourism · Keynote Speaker · Podcast Host · EU Expert on AI</p>
          <p className={`text-sm leading-relaxed mb-5 max-w-2xl ${dm ? "text-slate-400" : "text-[#6b7a7d]"}`}>
            EU-recognised expert on AI and tourism. Author of <em>Data Driven Destinations</em>, host of <em>Il Futuro del Turismo</em>, and keynote speaker for DMOs and hotel groups across Europe.
          </p>
          <div className="flex flex-wrap gap-2">
            {links.map(({ label, href, Icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer"
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full category-tag transition-all ${dm ? "bg-[#252e2f] text-slate-400 hover:bg-[#303b3c] hover:text-slate-200" : "bg-[#f3f4f5] text-[#6b7a7d] hover:bg-[#e7e8e9] hover:text-[#191c1d]"}`}>
                <Icon className="w-3 h-3" />{label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditsSection;
